import { getImage } from '@utils/imageHelper';

const v2 = (file) => getImage(`referrals/v2/${file}`);

export const ASSETS = {
  heroGift: v2('hero-gift.svg'),
  heroIpad: v2('hero-ipad.svg'),
  heroConfetti: v2('hero-confetti.svg'),
  heroTitleSpark: v2('hero-title-spark.svg'),
  carouselDotActive: v2('carousel-dot-active.svg'),
  carouselDotInactive: v2('carousel-dot-inactive.svg'),
  saleIcon: v2('sale-icon.svg'),
  messageCloud1: v2('message-cloud-1.svg'),
  messageCloud2: v2('message-cloud-2.svg'),
  podium: v2('podium.svg'),
  mobilePodiumScene: v2('mobile-podium-scene.png'),
  mobilePodiumBunting: v2('mobile-podium-bunting.png'),
  mobilePodiumPillar1: v2('mobile-podium-pillar-1.png'),
  mobilePodiumPillar2: v2('mobile-podium-pillar-2.png'),
  mobilePodiumPillar3: v2('mobile-podium-pillar-3.png'),
  mobilePodiumCrown: v2('mobile-podium-crown.png'),
  mobilePodiumEarningsTrophy: v2('mobile-podium-earnings-trophy.png'),
  mobileLadderCheck: v2('mobile-ladder-check.svg'),
  mobileLadderNextTail: v2('mobile-ladder-next-badge-tail.svg'),
  mobileFinalRewardScene: v2('mobile-final-reward-scene.png'),
  mobileFinalRewardGlow: v2('mobile-final-reward-glow.svg'),
  historyCheck: v2('history-check.svg'),
  historyAttention: v2('history-attention.svg'),
  remindClock: v2('remind-clock.svg'),
  leaderboardTrophy: v2('leaderboard-trophy.svg'),
  emptySpot: v2('empty-spot.svg'),
  emptyRefer: v2('empty-refer.svg'),
  messageLock: v2('message-lock.svg'),
  termsPlus: getImage('levels/plus.svg'),
  termsMinus: getImage('levels/minus.svg'),
  headerGift: v2('header-gift.svg'),
  homeHunter: v2('hunter.svg'),
  touchpointEllipse: v2('touchpoint-ellipse.svg'),
  touchpointEuroTrip: v2('touchpoint-euro-trip.png'),
  touchpointPs5: v2('touchpoint-ps5.svg'),
  claimTick: v2('claim-tick.svg'),
  finalRewardStar: v2('final-reward-star.svg'),
  ladderMarkerCheck: v2('ladder-marker-check.svg'),
  ladderMarkerLock: v2('message-lock.svg'),
  country: v2('country.svg'),
  whatsapp: v2('whatsapp.svg'),
  cmsModalClose: v2('cms-modal-close.svg')
};

export const REFERRAL_GIFT_VARIANT = {
  HUNTER: 'hunter',
  IPAD: 'ipad',
  PS5: 'ps5',
  EURO_TRIP: 'euro_trip'
} as const;

export type ReferralGiftVariant =
  typeof REFERRAL_GIFT_VARIANT[keyof typeof REFERRAL_GIFT_VARIANT];

export const LOGGED_OUT = {
  heroTitle: 'Exciting prizes await!',
  heroBody:
    'Stand a chance to win exciting prizes like an iPad A15 and many more...',
  codePlaceholder: 'XXXXXXXX'
};

export const LIST_EMPTY = {
  inviteesTitle: 'Oops! No invitees yet',
  historyTitle: 'No activity yet',
  subtitle: 'Invite your friends and stand a chance to win a trip to Europe ✈️',
  cta: 'Refer your friends'
};

/* Open accordion header from the Terms frame (364:24534). */
export const TERMS_HEADER_BG = 'var(--color-blue-bg)';

/* Rank treatments from the leaderboard rows. */
export const RANK_STYLES = {
  gold: {
    background: 'var(--color-bg-yellow)',
    score: 'var(--color-yellow-1)',
    nameColor: 'var(--color-brown-2)',
    icon: v2('medal-gold.svg')
  },
  silver: {
    background: 'var(--color-base-light-0)',
    score: 'var(--color-text-secondary)',
    icon: v2('medal-silver.svg')
  },
  bronze: {
    background: 'var(--color-orange-1)',
    score: 'var(--color-brown-3)',
    icon: v2('medal-bronze.svg')
  },
  rest: {
    background: 'var(--color-blue-bg)',
    score: 'var(--color-accent-blue)'
  }
};

/** Mobile list rows — Figma 387:48616. */
export const MOBILE_RANK_STYLES = {
  gold: {
    background: '#fff8dd',
    score: '#fabc00',
    icon: v2('medal-gold.svg')
  },
  silver: {
    background: '#eaeaea',
    score: '#6f6f6f',
    icon: v2('medal-silver.svg')
  },
  bronze: {
    background: '#ffeee2',
    score: '#c95a1e',
    icon: v2('medal-bronze.svg')
  },
  rest: {
    background: '#f0f7ff',
    score: '#2d81f7',
    rankBadgeBg: 'rgba(21, 124, 242, 0.1)',
    rankBadgeText: '#0077ff'
  }
} as const;

export const TABS = {
  OVERVIEW: 'overview',
  DASHBOARD: 'dashboard',
  HISTORY: 'history',
  TERMS: 'terms'
} as const;

export const TAB_ITEMS = [
  { id: TABS.OVERVIEW, label: 'Overview' },
  { id: TABS.DASHBOARD, label: 'Dashboard' },
  { id: TABS.HISTORY, label: 'History' },
  { id: TABS.TERMS, label: 'Terms' }
];

export const getVisibleTabItems = (isLoggedOut?: boolean) =>
  isLoggedOut
    ? TAB_ITEMS.filter(
        (tab) => tab.id !== TABS.DASHBOARD && tab.id !== TABS.HISTORY
      )
    : TAB_ITEMS;

export const REMINDER_TEMPLATE =
  "Arre {name}, you still haven't joined? Use {CODE} at checkout, cheaper for you. {link}";
